import { render, staticRenderFns } from "./JobOwnerPackages.vue?vue&type=template&id=13835ba2&"
import script from "./JobOwnerPackages.vue?vue&type=script&lang=js&"
export * from "./JobOwnerPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports